function setCurrentYear() {
    const date = new Date();
    const currentYearWrapper = document.querySelector('.js-current-year');
    currentYearWrapper.innerHTML = `${date.getFullYear()}`;
}

runIfElementExist(setCurrentYear, '.js-current-year');
